//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref } from '@vue/composition-api'
import { required, emailValidator } from '@core/utils/validation'

export default {
  setup() {
    const firstName = ref('')
    const email = ref('')
    const form = ref(null)
    const validate = () => {
      form.value.validate()
    }

    return {
      firstName,
      email,
      validate,
      form,

      // validation rules
      required,
      emailValidator,
    }
  },
}
